import { render, staticRenderFns } from "./GoalIndexSubject.vue?vue&type=template&id=0f2ce2ed&scoped=true"
import script from "./GoalIndexSubject.vue?vue&type=script&lang=js"
export * from "./GoalIndexSubject.vue?vue&type=script&lang=js"
import style0 from "./GoalIndexSubject.vue?vue&type=style&index=0&id=0f2ce2ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2ce2ed",
  null
  
)

export default component.exports